<div class="modal-container">
  <div class="modal-header border-0 justify-content-between">
    <h1 class="modal-title text-center text-primary-color">
      {{isEditable == true ? this.enumPopUpTitles.ADD : this.enumPopUpTitles.EDIT}} {{enumPopUpTitles.COMMENT}}
    </h1>
    <div class="hand d-flex align-items-center">
      <div *ngIf="!isEditable" class="ps-3 p-r-10">
        <!-- <app-svg-icon
          (click)="onDeleteComment()"
          [src]="'./assets/SVGIcons/deleteicon.svg'"
          class="h-33px"
        >
        </app-svg-icon> -->
         <app-svg 
          (click)="onDeleteComment()"
          class="h-33px"
          iconType="Delete"
           
           >                        
            </app-svg>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div class="text-center box">
      <div class="form-floating">
         <!-- <textarea [innerHTML]="getFormattedComment()"
          #commentEditor
          contenteditable="true"
          class="form-control resize mention-item"
          placeholder="Leave a comment here"
          id="floatingTextarea"
          autocomplete="off"
          [(ngModel)]="insertComment"
          [ngClass]="{
            'border-red': !insertComment && submited
          }"
          [mentionConfig]="{ items: items, labelKey: 'userName'}"
          [mentionListTemplate]="mentionListTemplate"
          
        ></textarea>  -->

        <div class="CommentBox rounded overflow-auto colorText"
         [ngClass]="{
            'border-red': !newComment && submited
          }"
        [mentionConfig]="{ items: items, labelKey: 'userName'}"
        [mentionListTemplate]="mentionListTemplate"
        (itemSelected)="itemSelected($event)"
        contenteditable="true"
        id="my-content"
        [innerHTML]="insertComment"
        (input)="updateComment($event)"
        [style.height]="'8rem'" 
      >
      </div>
        
        <label for="floatingTextarea" [ngClass]="{'font12': newComment}"
          >Comment<i class="fst-normal ps-1 p-0 text-danger">*</i></label
        >
        <span
          *ngIf="insertComment || newComment"
          (click)="newComments()"
          class="position-absolute top-0 start-0 hand"
          >
        <!-- <app-svg-icon
            class="svgIcon"
            [src]="'../../../../../../../assets/SVGIcons/undoSVG.svg'"
          ></app-svg-icon>
          </app-svg-icon> -->
         <app-svg 
          class="svgIcon"
          iconType="UndoSVG">                        
         </app-svg>  
        </span>

        <!-- @mention section  -->
        <ng-template #mentionListTemplate let-item="item" class="mentionList">
          <div class="d-flex rounded mx-0 px-0 d-flex align-items-center"> 
            <div class="mx-0 px-0 ">
              <img class="mr-3 my-0 rounded-circle" [src]="item.profileUrl" alt="" width="30"
                height="30"
                onerror="this.src='../../../../../../assets/SVGIcons/default.png'"
                >
            </div>
            <div class="mx-0 px-0 text-truncate">
              <span class="f-12 my-0 py-0 mentioned-name">{{item.userName}}</span><br>
              <span class="font-10 my-0 py-0">{{item.email}}</span>
            </div>
          </div>
        </ng-template>
        <!-- @mention section  -->
      </div>
    </div>
    <!-- <div class="text-center mb-3">
      <div class="form-floating">
        <textarea
          class="form-control resize"
          placeholder="Leave a comment here"
          [(ngModel)]="insertUpdateTaskCommentModel.comment"
          id="floatingTextarea"
          style="height: '150px'"
          autocomplete="off"
        ></textarea>
        <label for="floatingTextarea"
          >Comment<i class="fst-normal ps-1 p-0 text-danger">*</i></label
        >
      </div>
    </div> -->
  </div>
  <div class="modal-footer border-0 justify-content-end">
    <div class="m-0 d-flex gap-3">
      <app-button
        [buttonType]="'button'"
        [button_2]="true"
        [buttonClass]="'button button-info popup-button'"
        (click)="activeModal.close()"
        [buttonLable]="enumButtonName.CANCEL"
      ></app-button>
      <app-button class="commentBtn"
        [buttonType]="'submit'"
        [button_2]="true"
        [buttonClass]="newComment ? 'button button-primary popup-button': 'button dark-info popup-button'"
        (click)="isEditable == true ? addComment():editComment()"
        [buttonLable]="isEditable == true ? enumButtonName.ADD : enumButtonName.SAVE"
      ></app-button>
      <!-- [buttonClass]=" isEditable == true? 'button dark-info mx-0': 'button button-primary mx-0'" -->

    </div>
  </div>
</div>
